/* tslint:disable */
/* eslint-disable */
/**
 * crm-screener
 * crm-screener
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface LeadStatus
 */
export interface LeadStatus {
    /**
     * 
     */
    id: string;
    /**
     * 
     */
    name: string;
    /**
     * 
     */
    is_default?: boolean;
    /**
     * 
     */
    color?: string;
    /**
     * 
     */
    background_color?: string;
}

/**
 * Check if a given object implements the LeadStatus interface.
 */
export function instanceOfLeadStatus(value: object): value is LeadStatus {
    if (!('id' in value) || value['id'] === undefined) return false;
    if (!('name' in value) || value['name'] === undefined) return false;
    return true;
}

export function LeadStatusFromJSON(json: any): LeadStatus {
    return LeadStatusFromJSONTyped(json, false);
}

export function LeadStatusFromJSONTyped(json: any, ignoreDiscriminator: boolean): LeadStatus {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'],
        'name': json['name'],
        'is_default': json['is_default'] == null ? undefined : json['is_default'],
        'color': json['color'] == null ? undefined : json['color'],
        'background_color': json['background_color'] == null ? undefined : json['background_color'],
    };
}

export function LeadStatusToJSON(json: any): LeadStatus {
    return LeadStatusToJSONTyped(json, false);
}

export function LeadStatusToJSONTyped(value?: LeadStatus | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'name': value['name'],
        'is_default': value['is_default'],
        'color': value['color'],
        'background_color': value['background_color'],
    };
}

